<div class="row">
  <div class="col-12">
    <!-- Üst Butonlar -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ 'System Users' | localize }}</h2>
      <button mat-raised-button color="primary" (click)="openKeycloakUserModal()" class="d-flex align-items-center gap-2">
        <i-tabler name="users"></i-tabler>
        {{ 'SystemUser.KeycloakUsers' | localize }}
      </button>
    </div>

    <!-- Search/Filter Form -->
    <mat-card class="cardWithShadow mb-4">
      <mat-card-content>
        <form class="row g-3 align-items-end" (ngSubmit)="applyNameFilter()">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'SystemUser.Search' | localize }}</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="searchName"
                name="searchName"
                [placeholder]="'SystemUser.Search' | localize"
                (keyup.enter)="applyNameFilter()">
              <button matSuffix mat-icon-button type="submit">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'SystemUser.StatusFilter' | localize }}</mat-label>
              <mat-select
                [(ngModel)]="statusFilter"
                name="statusFilter"
                (selectionChange)="applyStatusFilter()">
                <mat-option [value]="null">{{ 'SystemUser.AllStatus' | localize }}</mat-option>
                <mat-option [value]="true">{{ 'SystemUser.Active' | localize }}</mat-option>
                <mat-option [value]="false">{{ 'SystemUser.Inactive' | localize }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>
    </mat-card>

    <!-- Data Table -->
    <mat-card class="cardWithShadow">
      <mat-card-content class="p-0">
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" matSort class="w-100">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="id">
                {{ getColumnHeader('id') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">
                <span class="badge bg-light-primary text-primary">{{ user.id }}</span>
              </td>
            </ng-container>

            <!-- UserID Column -->
            <ng-container matColumnDef="userId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="userId">
                {{ getColumnHeader('userId') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">
                <span class="text-primary fw-semibold">{{ user.userId }}</span>
              </td>
            </ng-container>

            <!-- First Name Column -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">
                {{ getColumnHeader('firstName') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
            </ng-container>

            <!-- Last Name Column -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">
                {{ getColumnHeader('lastName') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="email">
                {{ getColumnHeader('email') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">
                <small class="fw-medium">{{ user.email }}</small>
              </td>
            </ng-container>

            <!-- Is Enabled Column -->
            <ng-container matColumnDef="isEnabled">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="isEnabled">
                {{ getColumnHeader('isEnabled') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">
                <mat-slide-toggle
                  [checked]="user.isEnabled"
                  (change)="toggleUserStatus(user)"
                  color="primary">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                {{ getColumnHeader('actions') | localize }}
              </th>
              <td mat-cell *matCellDef="let user">
                <div class="d-flex gap-2">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="openRoleAssignmentModal(user)"
                    [title]="'SystemUser.AssignRole' | localize">
                    <i-tabler name="user-check"></i-tabler>
                  </button>
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="deleteSystemUser(user)"
                    [title]="'SystemUser.Delete' | localize">
                    <i-tabler name="trash"></i-tabler>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <!-- Loading State -->
          <div *ngIf="isLoading" class="text-center py-5">
            <mat-spinner diameter="40" class="mx-auto mb-3"></mat-spinner>
            <div class="text-muted">Yükleniyor...</div>
          </div>

          <!-- Empty State -->
          <div *ngIf="!isLoading && dataSource.data.length === 0" class="text-center py-5">
            <i-tabler name="users-off" class="mb-3 text-muted" style="font-size: 48px;"></i-tabler>
            <div class="text-muted">{{ 'SystemUser.KayitYok' | localize }}</div>
          </div>
        </div>

        <!-- Pagination -->
        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="pageSizeOptions"
          (page)="onPageChange($event)"
          showFirstLastButtons>
        </mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Keycloak Kullanıcı Seçim Modalı -->
<ng-template #keycloakUserModal>
  <mat-card class="cardWithShadow">
    <mat-card-header class="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div class="d-flex flex-column">
        <mat-card-title class="mb-0">{{ 'SystemUser.KeycloakUsers' | localize }}</mat-card-title>
        <mat-card-subtitle class="text-muted">Keycloak'tan kullanıcı seçin</mat-card-subtitle>
      </div>
      <button mat-icon-button (click)="closeKeycloakModal()" aria-label="Close" class="flex-shrink-0">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content class="p-3">
      <!-- Arama -->
      <div class="row mb-4">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'SystemUser.Search' | localize }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="keycloakSearchText"
              (input)="filterKeycloakUsers()"
              (keyup.enter)="filterKeycloakUsers()"
              placeholder="İsim, soyisim, email veya kullanıcı adı ile arama...">
            <button
              matSuffix
              mat-icon-button
              (click)="filterKeycloakUsers()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <!-- Seçili Kullanıcı Sayısı -->
      <div *ngIf="selectedKeycloakUsers.length > 0" class="row mb-3">
        <div class="col-12">
          <div class="alert alert-info py-2 px-3 mb-0">
            <small class="d-flex align-items-center gap-2">
              <mat-icon class="text-info" style="font-size: 18px;">info</mat-icon>
              <span>{{ selectedKeycloakUsers.length }} kullanıcı seçildi</span>
            </small>
          </div>
        </div>
      </div>

      <!-- Kullanıcı Listesi -->
      <div class="row">
        <div class="col-12">
          <div style="max-height: 50vh; overflow-y: auto; overflow-x: hidden;">
            <table mat-table [dataSource]="keycloakUsers" class="w-100">
                              <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 50px; min-width: 50px;">
                    <mat-checkbox
                      (change)="$event ? toggleAllKeycloakUsers($event) : null"
                      [checked]="isAllKeycloakUsersSelected()"
                      [indeterminate]="isSomeKeycloakUsersSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let user" class="text-center">
                    <mat-checkbox
                      (change)="onKeycloakUserSelection($event, user)"
                      [checked]="isUserSelected(user)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                              <!-- UserID Column -->
                <ng-container matColumnDef="userId">
                  <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="min-width: 200px;">
                    {{ getColumnHeader('userId') | localize }}
                  </th>
                  <td mat-cell *matCellDef="let user">
                    <span class="text-primary fw-semibold">{{ user.userId }}</span>
                  </td>
                </ng-container>

                              <!-- First Name Column -->
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="min-width: 120px;">
                    {{ getColumnHeader('firstName') | localize }}
                  </th>
                  <td mat-cell *matCellDef="let user">
                    <span class="fw-medium">{{ user.firstName }}</span>
                  </td>
                </ng-container>

                <!-- Last Name Column -->
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="min-width: 120px;">
                    {{ getColumnHeader('lastName') | localize }}
                  </th>
                  <td mat-cell *matCellDef="let user">
                    <span class="fw-medium">{{ user.lastName }}</span>
                  </td>
                </ng-container>

                <!-- Email Column -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="min-width: 200px;">
                    {{ getColumnHeader('email') | localize }}
                  </th>
                  <td mat-cell *matCellDef="let user">
                    <small class="fw-medium">{{ user.email }}</small>
                  </td>
                </ng-container>

              <tr mat-header-row *matHeaderRowDef="['select', 'userId', 'firstName', 'lastName', 'email']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['select', 'userId', 'firstName', 'lastName', 'email'];"></tr>
            </table>

            <!-- Loading State -->
            <div *ngIf="isKeycloakLoading" class="text-center py-5">
              <mat-spinner diameter="40" class="mx-auto mb-3"></mat-spinner>
              <div class="text-muted">{{ 'SystemUser.LoadingKeycloakUsers' | localize }}</div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!isKeycloakLoading && keycloakUsers.length === 0" class="text-center py-5">
              <i-tabler name="users-off" class="mb-3 text-muted" style="font-size: 48px;"></i-tabler>
              <div class="text-muted">{{ 'SystemUser.NoKeycloakUsers' | localize }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seçili Kullanıcılar (Detaylı) -->
      <div *ngIf="selectedKeycloakUsers.length > 0" class="row mt-4">
        <div class="col-12">
          <div class="border rounded p-3 bg-light-primary">
            <h6 class="text-primary mb-3 fw-semibold">
              <mat-icon class="me-2" style="font-size: 18px;">people</mat-icon>
              Seçili Kullanıcılar ({{ selectedKeycloakUsers.length }})
            </h6>
            <div class="row g-2">
              <div *ngFor="let user of selectedKeycloakUsers" class="col-12 col-sm-6 col-lg-4">
                <div class="badge bg-primary text-white p-2 w-100 text-start d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1">
                    <div class="fw-medium">{{ user.firstName }} {{ user.lastName }}</div>
                    <small class="opacity-75">{{ user.userId }}</small>
                  </div>
                                     <button
                     type="button"
                     class="btn-close btn-close-white"
                     style="font-size: 0.7em;"
                     (click)="removeKeycloakUserFromSelection(user)">
                   </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>

    <!-- Modal Actions -->
    <mat-card-actions class="d-flex flex-column flex-md-row justify-content-end gap-2 p-3">
      <button
        mat-button
        class="order-2 order-md-1"
        (click)="dialog.closeAll()">
        {{ 'SystemUser.CancelSelection' | localize }}
      </button>
      <button
        mat-raised-button
        color="primary"
        class="order-1 order-md-2 d-flex align-items-center justify-content-center gap-2"
        (click)="applyKeycloakUserSelection()"
        [disabled]="selectedKeycloakUsers.length === 0 || isKeycloakLoading">
        <mat-icon>check</mat-icon>
        <span>{{ 'SystemUser.ApplySelection' | localize }}</span>
        <span *ngIf="selectedKeycloakUsers.length > 0" class="badge bg-light text-dark ms-2">
          {{ selectedKeycloakUsers.length }}
        </span>
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>

<!-- Rol Atama Modalı -->
<ng-template #roleAssignmentModal>
  <mat-card class="cardWithShadow">
    <!-- Modal Header -->
    <mat-card-header class="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div class="d-flex flex-column">
        <mat-card-title class="mb-0">{{ 'SystemUser.AssignRole' | localize }}</mat-card-title>
        <mat-card-subtitle *ngIf="currentUserForRoleAssignment" class="text-muted">
          {{ currentUserForRoleAssignment.firstName }} {{ currentUserForRoleAssignment.lastName }}
        </mat-card-subtitle>
      </div>
      <button mat-icon-button (click)="closeRoleAssignmentModal()" aria-label="Close" class="flex-shrink-0">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content class="p-3">
      <!-- Arama -->
      <div class="row mb-4">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'SystemUser.SearchRole' | localize }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="roleSearchText"
              (input)="filterRoles()"
              (keyup.enter)="filterRoles()"
              placeholder="Rol adı ile arama...">
            <button
              matSuffix
              mat-icon-button
              (click)="filterRoles()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <!-- Seçili Rol Sayısı -->
      <div *ngIf="selectedRoles.length > 0" class="row mb-3">
        <div class="col-12">
          <div class="alert alert-info py-2 px-3 mb-0">
            <small class="d-flex align-items-center gap-2">
              <mat-icon class="text-info" style="font-size: 18px;">shield</mat-icon>
              <span>{{ selectedRoles.length }} rol seçildi</span>
            </small>
          </div>
        </div>
      </div>

      <!-- Rol Listesi -->
      <div class="row">
        <div class="col-12">
          <div style="max-height: 50vh; overflow-y: auto; overflow-x: hidden;">
            <table mat-table [dataSource]="availableRoles" class="w-100">
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 50px; min-width: 50px;">
                  <mat-checkbox
                    (change)="$event ? toggleAllRoles($event) : null"
                    [checked]="isAllRolesSelected()"
                    [indeterminate]="isSomeRolesSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let role" class="text-center">
                  <mat-checkbox
                    (change)="onRoleSelection($event, role)"
                    [checked]="isRoleSelected(role)">
                  </mat-checkbox>
                </td>
              </ng-container>

                            <!-- Role ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="width: 80px; min-width: 80px;">
                  {{ 'SystemUser.RoleID' | localize }}
                </th>
                <td mat-cell *matCellDef="let role">
                  <span class="badge bg-light-primary text-primary">{{ role.id }}</span>
                </td>
              </ng-container>

              <!-- Role Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="min-width: 200px;">
                  {{ 'SystemUser.RoleName' | localize }}
                </th>
                <td mat-cell *matCellDef="let role">
                  <span class="text-primary fw-semibold">{{ role.name }}</span>
                </td>
              </ng-container>

              <!-- Is Active Column -->
              <ng-container matColumnDef="isActive">
                <th mat-header-cell *matHeaderCellDef class="fw-semibold" style="width: 100px; min-width: 100px;">
                  {{ 'SystemUser.Active' | localize }}
                </th>
                <td mat-cell *matCellDef="let role">
                  <span class="badge" [ngClass]="role.active ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
                    {{ role.active ? ('SystemUser.Active' | localize) : ('SystemUser.Inactive' | localize) }}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['select', 'id', 'name', 'isActive']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['select', 'id', 'name', 'isActive'];"></tr>
            </table>

            <!-- Loading State -->
            <div *ngIf="isRoleLoading" class="text-center py-5">
              <mat-spinner diameter="40" class="mx-auto mb-3"></mat-spinner>
              <div class="text-muted">{{ 'SystemUser.LoadingRoles' | localize }}</div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!isRoleLoading && availableRoles.length === 0" class="text-center py-5">
              <i-tabler name="shield-off" class="mb-3 text-muted" style="font-size: 48px;"></i-tabler>
              <div class="text-muted">{{ 'SystemUser.NoRoles' | localize }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seçili Roller (Detaylı) -->
      <div *ngIf="selectedRoles.length > 0" class="row mt-4">
        <div class="col-12">
          <div class="border rounded p-3 bg-light-primary">
            <h6 class="text-primary mb-3 fw-semibold">
              <mat-icon class="me-2" style="font-size: 18px;">shield</mat-icon>
              Seçili Roller ({{ selectedRoles.length }})
            </h6>
            <div class="row g-2">
              <div *ngFor="let role of selectedRoles" class="col-12 col-sm-6 col-lg-4">
                <div class="badge bg-primary text-white p-2 w-100 text-start d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1">
                    <div class="fw-medium">{{ role.name }}</div>
                    <small class="opacity-75">ID: {{ role.id }}</small>
                  </div>
                  <button
                    type="button"
                    class="btn-close btn-close-white"
                    style="font-size: 0.7em;"
                    (click)="removeRoleFromSelection(role)">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>

    <!-- Modal Actions -->
    <mat-card-actions class="d-flex flex-column flex-md-row justify-content-end gap-2 p-3">
      <button
        mat-button
        class="order-2 order-md-1"
        (click)="closeRoleAssignmentModal()">
        {{ 'SystemUser.Cancel' | localize }}
      </button>
      <button
        mat-raised-button
        color="primary"
        class="order-1 order-md-2 d-flex align-items-center justify-content-center gap-2"
        (click)="applyRoleAssignment()"
        [disabled]="!hasRoleChanges() || isRoleLoading">
        <mat-icon>check</mat-icon>
        <span>{{ 'SystemUser.AssignSelectedRoles' | localize }}</span>
        <span *ngIf="selectedRoles.length > 0" class="badge bg-light text-dark ms-2">
          {{ selectedRoles.length }}
        </span>
      </button>
    </mat-card-actions>
  </mat-card>
</ng-template>
